module.exports = "<div #paypal></div>"